import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { StyleSheet } from "@react-pdf/renderer";
import VoTheme from "ui/theme/vocollege2";

export const useStylesBase = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      marginTop: theme.spacing(2),
    },
    box: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[10],
    },
    viewerWrapper: {
      alignItems: "center",
      borderRadius: theme.shape.borderRadius,
      display: "flex",
      flex: 1,
      justifyContent: "center",
      overflow: "hidden",
      // marginTop: theme.spacing(2),
      // padding: theme.spacing(1),
      position: "relative",
      // "&:after": {
      //   border: `10px solid ${theme.palette.common.white}`,
      //   bottom: theme.spacing(1),
      //   content: "''",
      //   display: "block",
      //   left: theme.spacing(1),
      //   position: "absolute",
      //   right: theme.spacing(1),
      //   top: theme.spacing(1),
      // },

      "@supports (-moz-appearance:none)": {
        marginTop: "-30px",
        "&:after": {
          background: VoTheme.palette.common.white,
          content: "''",
          left: 0,
          height: "30px",
          position: "absolute",
          right: 0,
          top: 0,
          zIndex: 1,
        },
      },
    },
    viewer: {
      border: "none",
      height: "100%",
      width: "100%",
    },
    // "@global": {
    //   "[mozdisallowselectionprint] #mainContainer": {
    //     border: "10px solid red",
    //   },
    // },
    loader: {
      bottom: "auto",
      left: "auto",
      position: "relative",
      right: "auto",
      top: "auto",
    },
  })
);

export const baseStyles = StyleSheet.create({
  page: {
    backgroundColor: "#FFF",
    flexDirection: "column",
    padding: VoTheme.spacing(2),
  },
  logo: {
    height: "auto",
    width: 130,
  },
  section: {
    marginTop: VoTheme.spacing(4),
  },
  grow: {
    flex: 1,
  },
  listItem: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    paddingLeft: VoTheme.spacing(1),
  },
  listItemDot: {
    marginRight: VoTheme.spacing(1),
    // marginLeft: VoTheme.spacing(-10),
  },
  uid: {
    color: VoTheme.palette.grey[300],
    fontSize: 8,
  },
});
